<template>
  <div class="container" id="container">
    <div id="dashboard" >
      <!-- Dashboard header -->
      <div class="dashboard__header mb-4 row no-gutters">

        <!-- Dashboard Title -->
        <div class="col-sm-12 col-md-4 pt-md-1 pt-sm-0 dashboard__header--col" ref="topTitle">
          <div>
            <svg class="dashboard__header--icon h-100 display-inline-block" width="40" height="32" viewBox="0 0 40 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0 24V16C0 14.8938 0.89375 14 2 14H4V26H2C0.89375 26 0 25.1063 0 24ZM22 6H29C31.7625 6 34 8.2375 34 11V28C34 30.2062 32.2062 32 30 32H10C7.79375 32 6 30.2062 6 28V11C6 8.2375 8.2375 6 11 6H18V2C18 0.89375 18.8937 0 20 0C21.1063 0 22 0.89375 22 2V6ZM11.5 16C11.5 17.3813 12.6187 18.5 14 18.5C15.3813 18.5 16.5 17.3813 16.5 16C16.5 14.6187 15.3813 13.5 14 13.5C12.6187 13.5 11.5 14.6187 11.5 16ZM23.5 16C23.5 17.3813 24.6187 18.5 26 18.5C27.3813 18.5 28.5 17.3813 28.5 16C28.5 14.6187 27.3813 13.5 26 13.5C24.6187 13.5 23.5 14.6187 23.5 16ZM36 14H38C39.1063 14 40 14.8938 40 16V24C40 25.1063 39.1063 26 38 26H36V14ZM12.0121 22.6881C12.4242 22.2136 13.1417 22.1612 13.6183 22.5694L13.6246 22.5745C13.6335 22.5818 13.6514 22.5961 13.6781 22.6164C13.7315 22.6571 13.8203 22.7217 13.9443 22.8026C14.1923 22.9644 14.5807 23.1909 15.1088 23.421C16.1621 23.8799 17.7807 24.3571 19.9688 24.3571C22.1568 24.3571 23.7754 23.8799 24.8287 23.421C25.3568 23.1909 25.7452 22.9644 25.9932 22.8026C26.1172 22.7217 26.206 22.6571 26.2594 22.6164C26.2861 22.5961 26.304 22.5818 26.3129 22.5745L26.3192 22.5694C26.7958 22.1612 27.5133 22.2136 27.9254 22.6881C28.3393 23.1647 28.2884 23.8865 27.8119 24.3004L27.0625 23.4375C27.8119 24.3004 27.8114 24.3008 27.811 24.3011L27.8101 24.3019L27.8081 24.3037L27.8034 24.3077L27.7914 24.3179C27.7821 24.3257 27.7705 24.3353 27.7564 24.3468C27.7283 24.3697 27.6905 24.3997 27.643 24.4358C27.5482 24.508 27.4145 24.6045 27.2421 24.7169C26.8974 24.9418 26.3971 25.2309 25.7416 25.5165C24.4277 26.0889 22.4995 26.6429 19.9688 26.6429C17.438 26.6429 15.5098 26.0889 14.1959 25.5165C13.5404 25.2309 13.0401 24.9418 12.6954 24.7169C12.523 24.6045 12.3893 24.508 12.2945 24.4358C12.247 24.3997 12.2092 24.3697 12.1811 24.3468C12.167 24.3353 12.1554 24.3257 12.1461 24.3179L12.1341 24.3077L12.1294 24.3037L12.1274 24.3019L12.1265 24.3011C12.1261 24.3008 12.1256 24.3004 12.875 23.4375L12.1256 24.3004C11.6491 23.8865 11.5982 23.1647 12.0121 22.6881Z" fill="#2B4D75"/>
            </svg>
            <h1 class="dashboard__header--title m-0 header">Autopilot</h1>
          </div>
        </div>

        <!-- Date Range -->
        <div class="col-sm-12 col-md-8 text-right dashboard__header--col-right">
          <div class="dashboard__header--picker display-table-cell mt-sm-2 mt-md-2 mt-lg-0 display-inline-block">
            <date-range-picker @toggle="detectDateRangeState" v-clickaway="closeDateRangePicker" @update="updateDatee" ref="picker" opens="left" :locale-data="{ firstDay: 1, format: 'DD-MM-YYYY', applyLabel: 'Apply', cancelLabel: 'Cancel' }" :showWeekNumbers="false" :timePicker="false" :autoApply="false" v-model="showDateRange" placeholder="mm/dd/yyyy">
              <div slot="input" slot-scope="picker">
                  <button class="btn btn--white display-table px-3" ref="btn-picker">

                      <svg class="display-table-cell mr-2" width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 15.4062C0 16.2861 0.713867 17 1.59375 17H13.2812C14.1611 17 14.875 16.2861 14.875 15.4062V6.375H0V15.4062ZM2.125 9.03125C2.125 8.73906 2.36406 8.5 2.65625 8.5H12.2188C12.5109 8.5 12.75 8.73906 12.75 9.03125V11.1562C12.75 11.4484 12.5109 11.6875 12.2188 11.6875H2.65625C2.36406 11.6875 2.125 11.4484 2.125 11.1562V9.03125ZM13.2812 2.125H11.6875V0.53125C11.6875 0.239062 11.4484 0 11.1562 0H10.0938C9.80156 0 9.5625 0.239062 9.5625 0.53125V2.125H5.3125V0.53125C5.3125 0.239062 5.07344 0 4.78125 0H3.71875C3.42656 0 3.1875 0.239062 3.1875 0.53125V2.125H1.59375C0.713867 2.125 0 2.83887 0 3.71875V5.3125H14.875V3.71875C14.875 2.83887 14.1611 2.125 13.2812 2.125Z" fill="#52749C"/>
                      </svg>
                      <!-- <span class="display-table-cell mr-1" v-if="dateFormat(picker.ranges['This year'][0]) == dateFormat(picker.startDate) && dateFormat(picker.ranges['This year'][1]) == dateFormat(picker.endDate)">This Year: </span>
                      <span class="display-table-cell mr-1" v-if="dateFormat(picker.ranges['This month'][0]) == dateFormat(picker.startDate) && dateFormat(picker.ranges['This month'][1]) == dateFormat(picker.endDate)">This Month: </span>
                      <span class="display-table-cell mr-1" v-if="dateFormat(picker.ranges['Last week'][0]) == dateFormat(picker.startDate) && dateFormat(picker.ranges['Last week'][1]) == dateFormat(picker.endDate)">Last Week: </span>
                      <span class="display-table-cell mr-1" v-if="dateFormat(picker.ranges['Last month'][0]) == dateFormat(picker.startDate) && dateFormat(picker.ranges['Last month'][1]) == dateFormat(picker.endDate)">Last Month: </span>
                      <span class="display-table-cell mr-1" v-if="dateFormat(picker.ranges.Today[0]) == dateFormat(picker.startDate) && dateFormat(picker.ranges.Today[1]) == dateFormat(picker.endDate)">Today: </span>
                      <span class="display-table-cell mr-1" v-if="dateFormat(picker.ranges.Yesterday[0]) == dateFormat(picker.startDate) && dateFormat(picker.ranges.Yesterday[1] == picker.endDate)">Yesterday: </span> -->
                      <span class="display-table-cell" v-if="picker.startDate == null && picker.endDate == null">Select date range</span>
                      <span class="display-table-cell mx-2" v-else>{{dateFormat(picker.startDate)}} - {{dateFormat(picker.endDate)}}</span>
                      <svg class="display-table-cell" width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.594098 0.908325L8.22252 0.908325C8.75074 0.908325 9.01526 1.54697 8.64176 1.92047L4.82755 5.73468C4.59602 5.96621 4.2206 5.96621 3.98907 5.73468L0.174856 1.92047C-0.198674 1.54697 0.0658798 0.908325 0.594098 0.908325Z" fill="#52749C"/>
                      </svg>
                  </button>
              </div>
            </date-range-picker>
          </div>
        </div>

      </div>

      <!-- Tasks Charts -->
      <div class="dashboard__header mb-4 row no-gutters" style="margin: 0 -7.5px">

        <!--  All Task with Status Done  -->
        <div class="col-md-4 dashboard__header--col" style="padding: 0 7.5px;height: 200px;">
          <mini-chart chartType="status" :subType="null" :updateDate="valueUpdateDate" :startDate="showDateRange.startDate" :endDate="showDateRange.endDate" ></mini-chart>
        </div>


        <!--  All Task with Status Failed -->
        <div class="col-md-4 dashboard__header--col" style="padding: 0 7.5px;height: 200px;">
          <mini-chart chartType="action_taken" :subType="null" :updateDate="valueUpdateDate" :startDate="showDateRange.startDate" :endDate="showDateRange.endDate"></mini-chart>
        </div>

        <!--  All Task with Status Failed -->
        <div class="col-md-4 dashboard__header--col" style="padding: 0 7.5px;height: 200px;">
          <mini-chart chartType="last_check" :subType="null" :updateDate="valueUpdateDate" :startDate="showDateRange.startDate" :endDate="showDateRange.endDate"></mini-chart>
        </div>

      </div>

      <!-- Table -->
      <div id="products-table">
        <!-- v-if="(listStrategies && listStrategies.length && !loading) || showSearch" -->
        <div class="products-table__search" >
            <s-input placeholder="Search for Strategie by domain or email" v-model="searchStrategie"></s-input>
        </div>
        <s-card class="products-table__card border-top-0 p-0">
          <s-card-body class="product-table__table p-0">
              <div class="product-table__table-container" @scroll="getScrollPos">
                  <div class="div-shadow-left" v-if="!hideShadows && scrollIn && scrollIn !== 'left' && listStrategies && listStrategies.length"></div>
                  <!-- listStrategies && listStrategies.length &&  -->
                  <!-- style="width: 1880px !important;" -->
                  <table v-if="(!loading) || showSearch" class="product-table__table--table"  id="myTable">
                      <thead class="product-table__table--header border-0 p-0 mb-4">
                          <!-- ID -->
                          <td class="text-truncate product-table__table--header-id">
                              <span>ID</span>
                          </td>
                          <!-- Name -->
                          <td class="text-truncate product-table__table--header-domain">
                              <span>Name</span>
                          </td>
                          <!-- Description -->
                          <!-- <td class="text-truncate product-table__table--header-domain">
                              <span>Description</span>
                          </td> -->
                          <!-- Created at -->
                          <td class="text-truncate product-table__table--header-trail-started cursor-pointer">
                              <span>Created at</span>
                              <svg @click.stop="sortByField('created_at')" class="display-table-cell ml-2" width="11" height="16" viewBox="0 0 11 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.741224 9L10.2588 9C10.9178 9 11.2479 9.8941 10.7819 10.417L6.02307 15.7569C5.73421 16.081 5.26581 16.081 4.97694 15.7569L0.218158 10.417C-0.247875 9.8941 0.0821946 9 0.741224 9Z" :fill="sortData.sort_type == 'desc' && sortData.sort_field=='created_at'?'#3FC886':'#9FB3CA'"/>
                                <path d="M0.741224 7L10.2588 7C10.9178 7 11.2479 6.1059 10.7819 5.583L6.02307 0.243106C5.73421 -0.0810348 5.26581 -0.0810349 4.97694 0.243105L0.218158 5.583C-0.247875 6.1059 0.0821946 7 0.741224 7Z" :fill="sortData.sort_type == 'asc' && sortData.sort_field=='created_at'?'#3FC886':'#9FB3CA'"/>
                              </svg>
                          </td>
                          <!-- STATUS -->
                          <td class="text-truncate product-table__table--header-charge-status cursor-pointer">
                              <span>STATUS</span>
                              <svg @click.stop="sortByField('status')" class="display-table-cell ml-2" width="11" height="16" viewBox="0 0 11 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.741224 9L10.2588 9C10.9178 9 11.2479 9.8941 10.7819 10.417L6.02307 15.7569C5.73421 16.081 5.26581 16.081 4.97694 15.7569L0.218158 10.417C-0.247875 9.8941 0.0821946 9 0.741224 9Z" :fill="sortData.sort_type == 'desc' && sortData.sort_field=='status'?'#3FC886':'#9FB3CA'"/>
                                <path d="M0.741224 7L10.2588 7C10.9178 7 11.2479 6.1059 10.7819 5.583L6.02307 0.243106C5.73421 -0.0810348 5.26581 -0.0810349 4.97694 0.243105L0.218158 5.583C-0.247875 6.1059 0.0821946 7 0.741224 7Z" :fill="sortData.sort_type == 'asc' && sortData.sort_field=='status'?'#3FC886':'#9FB3CA'"/>
                              </svg>
                          </td>
                          <!-- Last action -->
                          <td class="text-truncate product-table__table--header-trail-started cursor-pointer">
                              <span>Last action taken</span>
                              <svg @click.stop="sortByField('last_action_taken')" class="display-table-cell ml-2" width="11" height="16" viewBox="0 0 11 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.741224 9L10.2588 9C10.9178 9 11.2479 9.8941 10.7819 10.417L6.02307 15.7569C5.73421 16.081 5.26581 16.081 4.97694 15.7569L0.218158 10.417C-0.247875 9.8941 0.0821946 9 0.741224 9Z" :fill="sortData.sort_type == 'desc' && sortData.sort_field=='last_action_taken'?'#3FC886':'#9FB3CA'"/>
                                <path d="M0.741224 7L10.2588 7C10.9178 7 11.2479 6.1059 10.7819 5.583L6.02307 0.243106C5.73421 -0.0810348 5.26581 -0.0810349 4.97694 0.243105L0.218158 5.583C-0.247875 6.1059 0.0821946 7 0.741224 7Z" :fill="sortData.sort_type == 'asc' && sortData.sort_field=='last_action_taken'?'#3FC886':'#9FB3CA'"/>
                              </svg>
                          </td>
                          <!-- Last check -->
                          <td class="text-truncate product-table__table--header-trail-started cursor-pointer">
                              <span>Last check</span>
                              <svg @click.stop="sortByField('last_check')" class="display-table-cell ml-2" width="11" height="16" viewBox="0 0 11 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.741224 9L10.2588 9C10.9178 9 11.2479 9.8941 10.7819 10.417L6.02307 15.7569C5.73421 16.081 5.26581 16.081 4.97694 15.7569L0.218158 10.417C-0.247875 9.8941 0.0821946 9 0.741224 9Z" :fill="sortData.sort_type == 'desc' && sortData.sort_field=='last_check'?'#3FC886':'#9FB3CA'"/>
                                <path d="M0.741224 7L10.2588 7C10.9178 7 11.2479 6.1059 10.7819 5.583L6.02307 0.243106C5.73421 -0.0810348 5.26581 -0.0810349 4.97694 0.243105L0.218158 5.583C-0.247875 6.1059 0.0821946 7 0.741224 7Z" :fill="sortData.sort_type == 'asc' && sortData.sort_field=='last_check'?'#3FC886':'#9FB3CA'"/>
                              </svg>
                          </td>
                          <!-- Account -->
                          <td class="text-truncate product-table__table--header-trail-started">
                              <span>Account</span>
                          </td>

                          <!-- Details -->
                          <td class="text-truncate product-table__table--header-trail-started">
                              <span>Details</span>
                          </td>
                      </thead>
                      <tbody class="product-table__table--body">
                          <tr class="w-100 display-table-cell" v-if="loading && showSearch">
                              <s-loader :type="'scalify'" class="my-3" style="left:calc(50% - 42px);position:relative;"></s-loader>
                          </tr>
                          <tr class="w-100 display-table-cell" v-if="!loading && (listStrategies == null || listStrategies.length == 0)">
                              <p class="my-3 position-relative font-weight-sbold" style="left:40%;">No Results</p>
                          </tr>
                          <div v-if="listStrategies && listStrategies.length > 0">
                            <tr  v-show="!loading" v-for="(strategie, indexStrategie) in listStrategies" :key="indexStrategie" @click.stop="detailsStrategie(strategie.id)" class="product-table__table--row cursor-pointer">
                                <!-- ID -->
                                <td class="product-table__table--body-id">
                                  <p class="text-truncate">{{strategie.id}}</p>
                                </td>
                                <!-- Name -->
                                <td :tooltip-position="indexStrategie==0?'bottom':'top'" :tooltip="strategie.name" class="product-table__table--body-domain">
                                  <p class="text-truncate">{{strategie.name}}</p>
                                </td>
                                <!-- Description -->
                                <!-- <td :tooltip-position="indexStrategie==0?'bottom':'top'" :tooltip="strategie.description" class="product-table__table--body-domain">
                                    <p class="text-truncate">{{strategie.description?strategie.description:'-'}}</p>
                                </td> -->
                                <!-- Created at -->
                                <td class="product-table__table--body-trail-started">
                                  <p class="text-truncate">{{strategie.created_at?fromNow(strategie.created_at):'-'}}</p>
                                </td>
                                <!-- STATUS -->
                                <td class="product-table__table--body-charge-status">
                                    <img class="display-table-cell" v-if="strategie.status==true" src="../../assets/images/status/success.svg" alt="">
                                    <img class="display-table-cell" v-else-if="strategie.status==false" src="../../assets/images/status/secondary.svg" alt="">
                                    <span class="pl-2 display-table-cell text-truncate" >{{strategie.status?'Active':'Not Active'}}</span>
                                </td>
                                <!-- Last action -->
                                <td class="product-table__table--body-trail-started">
                                    <p class="text-truncate">{{strategie.last_action_taken?fromNow(strategie.last_action_taken):'-'}}</p>
                                </td>
                                <!-- Last check -->
                                <td class="product-table__table--body-trail-started">
                                    <p class="text-truncate">{{strategie.last_check?fromNow(strategie.last_check):'-'}}</p>
                                </td>
                                <!-- Account -->
                                <td class="product-table__table--body-trail-started">
                                    <p class="text-truncate text-primary cursor-pointer" @click.stop="accountDetails(strategie.account_id)" style="border-bottom: 1px solid #0E7DFF; width: max-content;">Go to account</p>
                                </td>
                                <!-- Details -->
                                <td class="product-table__table--body-trail-started">
                                  <button @click="detailsStrategie(strategie.id)" class="btn btn--primary">Details</button>
                                    <!-- <p class="text-truncate text-primary cursor-pointer" @click="detailsStrategie(strategie.id)" style="border-bottom: 1px solid #0E7DFF; width: max-content;">Go to account</p> -->
                                </td>
                            </tr>
                          </div>
                      </tbody>
                  </table>
                  <div class="div-shadow-right" v-if="!hideShadows && scrollIn && scrollIn !== 'right' && ((listStrategies && listStrategies.length)||showSearch)"></div>
              </div>
          </s-card-body>
          <s-card-body v-if="listStrategies && listStrategies.length && !showSearch && linkLoadMoreStrategies && !loading" class="p-0 product-table__load-more text-center">
              <button v-if="!loadingLoadMore" class="btn btn--white" @click="loadMoreStrategies()">Load More</button>
              <s-loader :type="'scalify'" v-else></s-loader>
          </s-card-body>
        </s-card>
      </div>

    </div>
  </div>
</template>

<script>
import moment from 'moment';
import MiniChart from './MiniChart.vue';
import DateRangePicker from 'vue2-daterange-picker';
// import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'


export default {
  name: 'autopilot',

  components:{
    MiniChart,
    DateRangePicker
  },

  props: {},

  computed:{
  },

  data(){
    return{
      showDateRange: {},
      valueUpdateDate: null,
      showRangePicker:false,
      listStrategies: [],
      searchStrategie: "",
      showSearch: false,
      showColumns: false,
      loading:false,
      hideShadows:false,
      scrollIn:"left",
      linkLoadMoreStrategies: false,
      loadingLoadMore: false,
      currentPage: 1,
      isLoadingSearch: false,
      sortData:{
        sort_type:"",
        sort_field:""
      }
    }
  },

  methods:{
    sortByField(field){
      if(field == this.sortData.sort_field){
        let new_sort_type = this.sortData.sort_type == 'asc' ? 'desc' : 'asc'
        this.sortData.sort_type = new_sort_type
      }
      else{
        this.sortData = {
          sort_type:"desc",
          sort_field:field
        }
      }
      this.currentPage = 1
      this.getTableData()
    },
    accountDetails(id){
      this.$router.push(`/account/${id}`);
    },
    closeDateRangePicker(){
      this.$nextTick(()=>{
        if(this.showRangePicker){
          this.$refs["btn-picker"].click()
        }
      })
    },
    detectDateRangeState(show){
      this.showRangePicker = show
    },
    async updateDatee(value){
      this.valueUpdateDate = value;
      this.loading = true;
      let start = moment(this.showDateRange.startDate).format('YYYY-MM-DD');
      let end = moment(this.showDateRange.endDate).format('YYYY-MM-DD');
      this.currentPage = 1;
      const strategies = await this.automationTable(start,end,this.currentPage,this.sortData);
      if (strategies && strategies.data) {
        this.listStrategies = strategies.data;

        if (strategies && strategies.data && strategies.data.length >= 25) {
          this.linkLoadMoreStrategies = true;
        }else{
          this.linkLoadMoreStrategies = false;
        }
        this.isLoadingSearch = false;
      }
      this.loading = false;
    },
    dateFormat(date){
      const m = moment(date);
      const ord = m.format("ll");
      return ord;
    },
    getScrollPos ({ target: { scrollLeft ,clientWidth, scrollWidth }}) {
      var scroll = "left"
      if(scrollLeft == 0){
          scroll = "left"
      }
      else if(scrollLeft+clientWidth < scrollWidth){
          scroll = "middle"
      }
      if(scrollLeft+clientWidth >= scrollWidth){
          scroll = "right"
      }
      this.scrollIn = scroll
    },
    updateTableWidth(){
      this.$nextTick(()=>{
        var x = document.getElementById("myTable")
        if(x){
            var items = x.children[0].children
            var w = 0
            for(var i=0;i<items.length;i++){
                w = w + items[i].clientWidth
            }
            if(parseInt(w) < 1110){
                this.hideShadows = true
            }
            else{
                this.hideShadows = false
            }
            x.style.width=w+'px'
            this.$forceUpdate()
        }
      })
    },
    async loadMoreStrategies(){
      try {
        this.loadingLoadMore = true;
        let start = moment(this.showDateRange.startDate).format('YYYY-MM-DD');
        let end = moment(this.showDateRange.endDate).format('YYYY-MM-DD');
        this.currentPage++;
        let detailsStrategies;
        if (this.isLoadingSearch) {
          detailsStrategies = await this.automationSearch(this.searchStrategie,this.currentPage);
          console.log('loadMore Search: ', detailsStrategies);
        }else{
          detailsStrategies = await this.automationTable(start,end,this.currentPage,this.sortData);
          console.log('loadMore Normale: ', detailsStrategies);

        }
        if (detailsStrategies && detailsStrategies.data) {
          this.currentPage = detailsStrategies.currentPage;
          this.listStrategies = this.listStrategies.concat(detailsStrategies.data);
          if (detailsStrategies && detailsStrategies.data && detailsStrategies.data.length >= 25) {
            this.linkLoadMoreStrategies = true;
          }else{
            this.linkLoadMoreStrategies = false;
          }
        }else{
          this.linkLoadMoreStrategies = false;
        }
        this.loadingLoadMore = false;
      } catch (error) {
        this.loadingLoadMore = false;
      }
    },
    detailsStrategie(id){
      this.$router.push(`/autopilot/${id}`);
    },
    async getTableData(){
      this.loading = true
      let start = moment(this.showDateRange.startDate).format('YYYY-MM-DD');
      let end = moment(this.showDateRange.endDate).format('YYYY-MM-DD');
      const strategies = await this.automationTable(start,end,this.currentPage,this.sortData);
      console.log('strategies: ', strategies);
      if (strategies && strategies.data) {
        this.listStrategies = strategies.data;

        if (strategies && strategies.data && strategies.data.length >= 25) {
          this.linkLoadMoreStrategies = true;
        }else{
          this.linkLoadMoreStrategies = false;
        }
      }
      this.loading = false
    }
  },

  async created(){
    this.showDateRange = {};
    this.showDateRange['endDate'] = new Date();
    var makeDate = new Date();
    this.showDateRange['startDate'] = new Date(new Date().setMonth(makeDate.getMonth()-1));
  },

  watch:{

    async searchStrategie(){


      if (this.searchStrategie == "") {
        this.loading = true;
        this.showSearch = true
        let start = moment(this.showDateRange.startDate).format('YYYY-MM-DD');
        let end = moment(this.showDateRange.endDate).format('YYYY-MM-DD');
        this.currentPage = 1;
        const strategies = await this.automationTable(start,end, this.currentPage,this.sortData);
        if (strategies && strategies.data) {
          this.listStrategies = strategies.data;

          if (strategies && strategies.data && strategies.data.length >= 25) {
            this.linkLoadMoreStrategies = true;
          }else{
            this.linkLoadMoreStrategies = false;
          }

        }
        this.loading = false;
        this.showSearch = false

      }else if(this.searchStrategie.length >= 3){
        this.loading = true;
        this.showSearch = true
        var t = 1000;
        this.currentPage = 1;

        clearTimeout(window.popTimeout);
        window.popTimeout = setTimeout(async () => {
          const resultSearch = await this.automationSearch(this.searchStrategie, this.currentPage);
          console.log('resultSearchresultSearch: ', resultSearch);

          if (resultSearch && resultSearch.data) {
            this.listStrategies = resultSearch.data;

            if (resultSearch && resultSearch.data && resultSearch.data.length >= 25) {
              this.linkLoadMoreStrategies = true;
            }else{
              this.linkLoadMoreStrategies = false;
            }

          }
          this.isLoadingSearch = true;

          this.showSearch = false
          this.loading = false;
        }, t);
      }

    }

  },

  async mounted(){
    this.getTableData()
  }


}
</script>

<style scoped>

</style>
